module.exports = __webpack_public_path__ + "static/img/QB50.74e43ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QB50.png
// module id = rvd1
// module chunks = 2